import React from 'react';
import { Toast as ToastPrimitive } from '@100mslive/roomkit-react';

export const Toast = ({ title, description, close = true, open, duration = 3000, onOpenChange, icon, ...props }) => {
    return (
        <ToastPrimitive.HMSToast
            title={title}
            description={description}
            open={open}
            isClosable={close}
            onOpenChange={onOpenChange}
            duration={duration}
            icon={icon}
            {...props}
        />
    );
};
